import { useEffect, useState } from "react"
import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle"
import { generalObjectBuilder, genericDelete, genericGet, genericPost, genericUpdate, UTILIZADORES_EXTENSION } from "../../services/api.service"
import { AccountConfigs } from "./Account.config";
import TableView from "../Common/TableView";
import { AccountDetails } from "../..";

export default function () {

    const [accountDetails, setAccountDetails] = useState<AccountDetails>(null);


    useEffect(() => {
        genericGet('/utilizadores/profile')
            .then((ad) => {
                setAccountDetails(ad);
            })
    }, [])


    return (<div>

        <CustomTitle text={"Gestão de conta"} />

        <div className="flex p-5 items-center">
            <div className="h-20 w-20 rounded-full bg-cyan-600"></div>
            {accountDetails ?
                <div className="ml-4">
                    <p><span style={{ fontWeight: 'bold', marginRight: 15 }}>Nome:</span> {accountDetails.name}</p>
                    <p><span style={{ fontWeight: 'bold', marginRight: 15 }}>Email: </span> {accountDetails.email}</p>
                    <p><span style={{ fontWeight: 'bold', marginRight: 15 }}>Conta: </span> {accountDetails.roles}</p>
                </div> : null}
        </div>




        <CustomTitle text={"Contas"} />
        <TableView
            postEntity={genericPost(UTILIZADORES_EXTENSION + '/register')}
            editEntity={genericUpdate(UTILIZADORES_EXTENSION)}
            deleteEntity={genericDelete(UTILIZADORES_EXTENSION)}
            addButtonText={"Novo Utilizador"}
            tableConfigs={AccountConfigs}
            entityName={"Utilizador"}
            dataBuildFunction={generalObjectBuilder(AccountConfigs)}
            configMapKey={'utilizadores'}
            reroute={true}
        />



    </div>)


}